import { createAsyncTypes } from 'utils/ActionCreator'

export const DISCLAIMERS_REQUEST_ASYNC = createAsyncTypes(
  'DISCLAIMERS_REQUEST',
  'Settings/Disclaimers'
)
export const DISCLAIMERS_ADD_ASYNC = createAsyncTypes(
  'DISCLAIMERS_ADD_ASYNC',
  'Settings/Disclaimers'
)
export const DISCLAIMERS_UPDATE_ASYNC = createAsyncTypes(
  'DISCLAIMERS_UPDATE_ASYNC',
  'Settings/Disclaimers'
)
